import { call, select, takeLatest } from 'redux-saga/effects';
import { GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { UwContext } from '@ps20-frontend/uw';
import { IAppState } from '../appState';
import { selectIsExtremwetterUWProcessNecessary } from '../../app/shared/selectors/produkt.selector';

export function* watchReevaluateUwRequirednessAfterLoad() {
  yield takeLatest(
    GlobalActions.SAVED_STATES_LOADED,
    safeSaga(reevaluateUwRequirednessAfterLoad, App.VHV_V2),
  );
}

export function* reevaluateUwRequirednessAfterLoad() {
  const state: IAppState = yield select();
  const globalPut = GlobalPut.getInstance();

  yield call(
    [globalPut, globalPut.put],
    new GlobalActions().setUnderwriterInfo(
      state.angebotsId,
      { [UwContext.NATURAL_HAZARDS]: selectIsExtremwetterUWProcessNecessary(state) },
      true,
    ),
  );
}
